// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__2v2kh","hideOnTablet":"styles_hideOnTablet__6KgkS","hideOnMobile":"styles_hideOnMobile__38gw3","priceColumn":"styles_priceColumn__2RCOU"};